module.exports = __webpack_public_path__ + "static/media/4_Snap-into-Mount.feb3d139.svg";